// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MockNativeMenu_wrapper__98iVi","iconButton":"MockNativeMenu_iconButton__HMGvz"};